"use client"

import { useState, useEffect } from "react"
import { useInView } from "react-intersection-observer"
import { useAuth } from "../../AuthContext"
import { useNavigate } from "react-router-dom"

export default function Skills({ profile }) {
  const { user } = useAuth()
  const [isOwner, setIsOwner] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (user && profile) {
      setIsOwner(user.id === profile.user_id)
    }
  }, [user, profile]) // Run only when `user` or `profile` changes

  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  })

  const handleEditSkill = (skillId) => {
    alert("you can't edit skill but you can delete and insert new skill.")
  }

  const handleRemoveSkill = async (proSkillId) => {
    if (window.confirm("Are you sure you want to remove this skill?")) {
      try {
        console.log("Removing skill:", proSkillId); // Log the skill ID being removed
        const response = await fetch(`http://localhost:5000/delete-proskills?proSkillId=${proSkillId}`, {
          method: "DELETE",
        });
        const result = await response.json();
        if (response.ok) {
          alert(result.message);
          navigate(`/ProProject`);
        } else {
          alert(`Failed to remove skill: ${result.error}`);
        }
      } catch (error) {
        console.error("Error removing skill:", error);
        alert("An error occurred while removing the skill.");
      }
    }
  }  

  const containerStyle = {
    padding: "4rem 1rem 1.25rem",
    position: "relative",
  }

  const flexContainerStyle = {
    display: "flex",
    flexWrap: "wrap",
    position: "relative",
    maxWidth: "1200px",
    margin: "0 auto",
    zIndex: 10,
  }

  const columnStyle = {
    width: "100%",
    padding: "0 1rem",
    marginBottom: "2.5rem",
    animation: "fadeIn 1s ease-out forwards",
  }

  const headingStyle = {
    fontSize: "2.25rem",
    marginBottom: "1.25rem",
    fontWeight: "bold",
  }

  const skillsHeadingStyle = {
    marginBottom: "1rem",
  }

  const skillsGridStyle = {
    display: "flex",
    flexWrap: "wrap",
    margin: "0 -0.5rem",
  }

  const skillsColumnStyle = {
    width: "100%",
    padding: "0 0.5rem",
  }

  const skillItemStyle = {
    marginBottom: "1rem",
  }

  const skillHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
  }

  const skillNameStyle = {
    fontWeight: "semibold",
  }

  const skillPercentStyle = {
    fontWeight: "semibold",
  }

  const skillBarContainerStyle = {
    height: "0.5rem",
    backgroundColor: "#e5e7eb",
    borderRadius: "0.25rem",
    overflow: "hidden",
  }

  const getSkillBarStyle = (percent) => ({
    height: "100%",
    width: inView ? `${percent}%` : "0%",
    transition: "width 1s",
    backgroundColor: "#7749F8",
  })

  useEffect(() => {
    const handleResize = () => {
      const isLargeScreen = window.innerWidth >= 1024
      const isMediumScreen = window.innerWidth >= 768

      const leftColumn = document.getElementById("skills-left-column")
      const rightColumn = document.getElementById("skills-right-column")
      const skillColumns = document.querySelectorAll(".skills-column")
      const gridContainer = document.getElementById("experience-grid")

      if (leftColumn && rightColumn) {
        if (isLargeScreen) {
          leftColumn.style.width = "50%"
          rightColumn.style.width = "50%"
          leftColumn.style.marginBottom = "0"

          if (gridContainer) {
            gridContainer.style.gridTemplateColumns = "1fr 1fr"
          }
        } else {
          leftColumn.style.width = "100%"
          rightColumn.style.width = "100%"

          if (gridContainer) {
            gridContainer.style.gridTemplateColumns = isMediumScreen ? "1fr 1fr" : "1fr"
          }
        }
      }

      if (skillColumns.length) {
        skillColumns.forEach((column) => {
          column.style.width = isMediumScreen ? "50%" : "100%"
        })
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <div style={containerStyle} id="skill" ref={ref}>
      <div style={flexContainerStyle}>
        <div id="skills-left-column" style={columnStyle}>
          <h1 style={headingStyle}>Skills</h1>
          <h3 style={skillsHeadingStyle}>My Skills</h3>
          <div style={skillsGridStyle}>
            {(profile?.skills || []).map((skill, index) => (
              <div key={index} className="skills-column" style={skillsColumnStyle}>
                <div style={skillItemStyle}>
                  <div style={skillHeaderStyle}>
                    <h6 style={skillNameStyle}>{skill.skill_name}</h6>
                    <h6 style={skillPercentStyle}>{skill.experience} years</h6>
                    {isOwner && (
                      <div>
                        <button onClick={() => handleEditSkill(skill.professional_skill_id)} title="Edit">
                          ✏️
                        </button>
                        <button onClick={() => handleRemoveSkill(skill.professional_skill_id)} title="Remove">
                          ❌
                        </button>
                      </div>
                    )}
                  </div>
                  <div style={skillBarContainerStyle}>
                    <div style={getSkillBarStyle(skill.experience * 10)}></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

